module.exports = "/_next/static/images/DataPipeline@3x-65ccaf4e649782b71d6fa284b7b774e2.webp";